import {http} from "@/api/HttpClient.ts";
import type Encounter from "@/encounter/model/Encounter.ts";
import type {DoorState, EncounterDoorState} from "@/encounter/doors/DoorState.ts";

export async function getDoorStates(encounter: Encounter): Promise<EncounterDoorState[]> {
    const response = await http.get<EncounterDoorState[]>(`/encounters/${encounter.id}/doorStates`);
    return response.data;
}

export async function saveDoorState(
    encounter: Encounter,
    doorId: string,
    state: DoorState,
): Promise<EncounterDoorState> {
    const response = await http.put<EncounterDoorState>(
        `/encounters/${encounter.id}/doorStates/${doorId}`,
        {state},
        {errorPresentation: "toast", errorMessage: "Der Türzustand konnte nicht geändert werden."},
    );
    return response.data;
}
